module.exports = __webpack_public_path__ + "static/media/2-VUKS.05776455.mp3";